module.exports = __webpack_public_path__ + "img/73_20.65485161.png";